import { Component, Input, OnInit } from '@angular/core';
import { emptyDatiqCellLocation, IDatiqCellLocation } from './models';

@Component({
    selector: 'datiq-cell-location',
    templateUrl: './datiq-cell-location.component.html',
    styleUrls: ['./datiq-cell-location.component.scss'],
})
export class DatiqCellLocationComponent implements OnInit {
    @Input()
    settings: IDatiqCellLocation;

    isTruncated: boolean;

    constructor() {}

    ngOnInit(): void {
        this.settings = !!this.settings
            ? { ...this.settings }
            : { ...emptyDatiqCellLocation };
        this.isTruncated = false;
    }
}
